import { FC } from 'react';
import ImageListingCard from '@/features/contentful/components/ImageListing/ImageListingCard';
import ContentLayout from '@/layouts/ContentLayout';

export type TImageListingCard = {
    title: string;
    subtitle: Document | undefined;
    image: string;
    buttonText: string;
    link: string;
    target: string;
};

interface ImageListingProps {
    imageCardContent: TImageListingCard[];
}

const ImageListing: FC<ImageListingProps> = ({ imageCardContent }) => {
    return (
        <div className="tw-w-full tw-bg-[#F2FAFF]  tw-py-[80px]">
            <div className="container">
                <div className="tw-flex tw-w-full tw-gap-5 tw-justify-center tw-flex-col md:tw-flex-row md:tw-justify-between md:tw-gap-10">
                    {imageCardContent.map((item) => (
                        <ImageListingCard
                            key={item.title}
                            title={item.title}
                            subtitle={item.subtitle}
                            image={item.image}
                            buttonText={item.buttonText}
                            link={item.link}
                            target={item.target}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ImageListing;
